module.exports = __webpack_public_path__ + "static/media/bs.0ac081cf.svg";